<div class="guided-questions">
  <app-contract-steps-bar [stepNo]="1"></app-contract-steps-bar>
  <h4 class="progress__title">{{ 'guided-questions.progress-bar-title' | translate }}</h4>
  @if (currentQuestion) {
    <app-progress
      [showPercentProgress]="false"
      [current]="currentQuestionIndex + 1"
      [max]="questionsQuantity">
    </app-progress>
  }
  <div class="guided-questions__content">
    @if (showQuestion()) {
      <div class="question">
        <h5 class="question__title">{{ currentQuestion.description }}</h5>
        <div class="question__answers">
          @for (answer of currentQuestion.domain.elements; track answer) {
            <div
              class="question__answer"
              [ngClass]="{'selected': answer.name === currentAnswer?.name}"
              (click)="toggleAnswer(answer)"
              [attr.data-test]= "'button-selectAnswer-' + answer.description">
              {{ answer.description }}
            </div>
          }
        </div>
        <div class="question__explanation">{{ answerExplanation }}</div>
      </div>
    }
    @if (isRecommendationStep()) {
      <app-recommendations
        [recommendations]="recommendations"
        (startOver)="goBackToStart()"
        (goBackOneStep)="goBackToPreviousQuestion()"
        (selectedContract)="selectContract($event)"
        [contractParams]="contractParams">
      </app-recommendations>
    }
    @if (currentQuestion) {
      <div class="question__actions">
        @if (showBackButton()) {
          <button
            type="button"
            class="button"
            (click)="goBackToPreviousQuestion()">
            {{ 'guided-questions.answer-back-btn' | translate }}
          </button>
        }
        <div class="question__actions--next">
          @if (showNextButton()) {
            <button
              type="button"
              class="button button--primary" [attr.data-test]="'button-next'"
              [disabled]="!skipAnswer && !currentAnswer"
              (click)="goToTheNextQuestion()">
              {{ 'guided-questions.answer-next-btn' | translate }}
            </button>
          }
          @if (showSkipButton()) {
            <button
              type="button"
              class="button" [attr.data-test]="'button-skip'"
              (click)="skipQuestion()">
              {{ 'guided-questions.answer-skip-btn' | translate }}
            </button>
          }
        </div>
      </div>
    }
    @if (showLoader) {
      <div
        class="guided-questions__loader loader__overlay"
        [ngClass]="{'fixed': isRecommendationStep()}">
        <span class="loading-animation"></span>
      </div>
    }
  </div>
</div>
